/** Matches `$kw-mobile` in @theme/styles/shared/_page-shell.scss: phones and iPad portrait. */
export const KW_MOBILE_QUERY = '(max-width: 1000px)';
